export default "__VITE_ASSET__0ff909d5__"